import { render, staticRenderFns } from "./SwsList.vue?vue&type=template&id=9cd2fdf0"
import script from "./SwsList.vue?vue&type=script&lang=js"
export * from "./SwsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports